import { IApplicationState } from '../../types/redux';

export const getIsNewbuildingPromoSnippetDisplayed = (state: IApplicationState) => state.config.isPromoSnippetDisplayed;
